import Button from '@rio-cloud/rio-uikit/Button';

export const FilterResetButton = ({
    statusFilter,
    onResetStatusFilter,
}: {
    statusFilter: string[];
    onResetStatusFilter: () => void;
}) => {
    if (statusFilter.length === 0) {
        return null;
    }

    return (
        <Button bsStyle='default' iconOnly onClick={onResetStatusFilter} data-testid='reset-status-filter'>
            <span className='uikit-icon icon-filter-active ' />
        </Button>
    );
};
